import { useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "@/components/Core/Button/Button";
import TextArea from "@/components/Core/TextArea/TextArea";
import { useOrganisation, useUpdateOrganisation } from "@/networking/organisation.hooks";
import { SettingsLeaf } from "./SettingsLeafLayout";

/** Advanced: raw JS injected into the logged-in dashboard. Power-user setting. */
const ScriptPage = () => {
	const { t } = useTranslation();
	const { data: organisation } = useOrganisation();
	const { mutate: updateOrganisation } = useUpdateOrganisation();
	const [dashboardScript, setDashboardScript] = useState(organisation?.dashboardScript || "");

	return (
		<SettingsLeaf
			title="Script"
			description="Javascript som exekveras när användare är inloggade på dashboard.origoworks.se. Använd detta för att integrera med tredjepartstjänster som kräver att en widget eller liknande läggs till på sidan. Ange utan <script>-taggar."
		>
			<TextArea
				height="200px"
				value={dashboardScript}
				onChangeText={setDashboardScript}
				placeholder="console.log('Hello world!');"
			/>
			<div>
				<Button onClick={() => updateOrganisation({ dashboardScript })}>{t("SAVE")}</Button>
			</div>
		</SettingsLeaf>
	);
};

export default ScriptPage;
